import '@/init/classComponentHooks';
import 'babel-polyfill';
import 'es6-promise/auto';
import * as uiv from 'uiv';
import Vue from 'vue';
import * as VueAuthImage from 'vue-auth-image';
import VueForm from 'vue-form';
import App from './App.vue';
import { config } from './config';
import msalBuilder from './init/msalSetup';
import router from './router';
import store from './store/store';

import './init/analyticsSetup';
import './init/initDirectives';
import './init/initFilters';
import './init/nprogressSetup';
import './init/snotifySetup';
import './styles/build.scss';

import sentryBuilder from '@/init/sentrySetup';

Vue.config.productionTip = false;

Vue.use(uiv);
Vue.use(VueAuthImage);
Vue.use(VueForm);

// Wait for MSAL setup to complete before creating Vue app
msalBuilder().then(() => {
    sentryBuilder(config);

    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app');
}).catch((error) => {
    // Still create the Vue app even if MSAL setup fails
    sentryBuilder(config);

    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app');
});
